module.exports = __webpack_public_path__ + "img/slide1.a93df460.png";